import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { API, IPaymentOptionNames } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { FormError } from '../../../components/FormError'
import { BlazeAlert } from '../../../components/BlazeAlert/BlazeAlert'

interface Props {
  onHide: () => void
  currentCompanyStore?: CurrentCompanyStore
  paymentId: string
  paymentOptionNames?: IPaymentOptionNames
}

interface State {
  email: string
  isSaving: boolean
  errorMessage?: string
}

@inject('currentCompanyStore')
@observer
export class EmailReceiptModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      email: '',
      isSaving: false,
    }
  }

  submit() {
    const company = this.props.currentCompanyStore!.company!
    this.setState({ isSaving: true })
    API.sendReceiptEmail(
      company.id,
      this.props.paymentId,
      this.state.email,
      this.props.paymentOptionNames,
    )
      .then(() => {
        this.props.onHide()
      })
      .catch(() => {
        this.setState({
          isSaving: false,
          errorMessage: `There was an error sending an email to ${this.state.email}`,
        })
      })
  }

  render() {
    let saveButton: JSX.Element
    if (!this.state.email) {
      saveButton = (
        <button className='btn btn-lg btn-primary w-100' disabled>
          Send email
        </button>
      )
    } else if (this.state.isSaving) {
      saveButton = (
        <button className='btn btn-lg btn-primary w-100' disabled>
          Sending...
        </button>
      )
    } else {
      saveButton = (
        <button
          className='btn btn-lg btn-primary w-100'
          onClick={(e) => {
            e.stopPropagation()
            this.submit()
          }}
        >
          Send email
        </button>
      )
    }

    return (
      <Modal isOpen={true} toggle={() => this.props.onHide()}>
        <ModalHeader toggle={() => this.props.onHide()}>Email receipt</ModalHeader>
        <ModalBody>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              this.submit()
            }}
          >
            <div className='form-group'>
              <input
                type='email'
                placeholder='Email'
                className='form-control form-control-lg'
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
              />
            </div>
            <div className='form-group'>{saveButton}</div>

            {this.state.errorMessage && (
              <BlazeAlert type='error' showIcon>
                {this.state.errorMessage}
              </BlazeAlert>
            )}
          </form>
        </ModalBody>
      </Modal>
    )
  }
}
